(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var desktopItems = Array.prototype.slice.call(document.querySelectorAll('[data-zsr-nav-item]'));
    var mobileItems = Array.prototype.slice.call(document.querySelectorAll('[data-zsr-mobile-nav-item]'));
    var desktopQuery = window.matchMedia('(min-width: 768px)');

    function closeDesktop(item, returnFocus) {
      var toggle = item.querySelector('[data-zsr-nav-toggle]');
      var panel = item.querySelector('[data-zsr-nav-panel]');
      if (!toggle || !panel) return;
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      panel.style.removeProperty('--zsr-panel-shift');
      if (returnFocus) toggle.focus();
    }

    function closeAllDesktop(except) {
      desktopItems.forEach(function (item) {
        if (item !== except) closeDesktop(item, false);
      });
    }

    function positionPanel(panel) {
      panel.style.setProperty('--zsr-panel-shift', '0px');
      var rect = panel.getBoundingClientRect();
      var gutter = 16;
      var shift = 0;
      if (rect.left < gutter) shift = gutter - rect.left;
      if (rect.right > window.innerWidth - gutter) shift = window.innerWidth - gutter - rect.right;
      panel.style.setProperty('--zsr-panel-shift', shift + 'px');
    }

    function openDesktop(item) {
      var toggle = item.querySelector('[data-zsr-nav-toggle]');
      var panel = item.querySelector('[data-zsr-nav-panel]');
      if (!toggle || !panel || !desktopQuery.matches) return;
      closeAllDesktop(item);
      panel.hidden = false;
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      positionPanel(panel);
    }

    desktopItems.forEach(function (item) {
      var toggle = item.querySelector('[data-zsr-nav-toggle]');
      var panel = item.querySelector('[data-zsr-nav-panel]');
      if (!toggle || !panel) return;
      panel.hidden = true;
      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        if (item.classList.contains('is-open')) closeDesktop(item, false);
        else openDesktop(item);
      });
      item.addEventListener('focusout', function () {
        window.requestAnimationFrame(function () {
          if (!item.contains(document.activeElement)) closeDesktop(item, false);
        });
      });
    });

    function closeMobile(item, returnFocus) {
      var toggle = item.querySelector('[data-zsr-mobile-nav-toggle]');
      var panel = item.querySelector('[data-zsr-mobile-nav-panel]');
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      if (returnFocus) toggle.focus();
    }

    function closeAllMobile(except) {
      mobileItems.forEach(function (item) {
        if (item !== except) closeMobile(item, false);
      });
    }

    mobileItems.forEach(function (item) {
      var toggle = item.querySelector('[data-zsr-mobile-nav-toggle]');
      var panel = item.querySelector('[data-zsr-mobile-nav-panel]');
      if (!toggle || !panel) return;
      panel.hidden = true;
      toggle.addEventListener('click', function () {
        var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
        closeAllMobile(item);
        toggle.setAttribute('aria-expanded', String(willOpen));
        panel.hidden = !willOpen;
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-zsr-nav-item]')) closeAllDesktop(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openDesktopItem = document.querySelector('[data-zsr-nav-item].is-open');
      if (openDesktopItem) {
        event.preventDefault();
        closeDesktop(openDesktopItem, true);
        return;
      }
      var openMobileToggle = document.querySelector('[data-zsr-mobile-nav-toggle][aria-expanded="true"]');
      if (openMobileToggle) {
        event.preventDefault();
        closeMobile(openMobileToggle.closest('[data-zsr-mobile-nav-item]'), true);
      }
    });

    window.addEventListener('resize', function () {
      closeAllDesktop(null);
    });
  });
})();
